import { useEffect, useState } from "react";
import { getUserCountry } from "../../../utils/utils";
import ReactMarkdown from "react-markdown";

interface PackageCardProps {
    packages: {
        id: string;
        name: string;
        description: string;
        actualPrice_egp: string;
        actualPrice_usd: string;
        discountPrice_usd:string;
        img_url:string;
        discountPrice_egp:string;
        courses: {
            id: string;
            name: string;
            img_url: string;
            actualPrice_egp: string;
            actualPrice_usd: string;
        }[];
    };
}

const PackageCard = ({ packages }: PackageCardProps) => {
    const [country, setCountry] = useState<string | null>(null);

    useEffect(() => {
        const userCountry = getUserCountry();
        setCountry(userCountry);
    }, []);

    return (
        <div className="p-4 bg-white rounded-2xl relative flex flex-col justify-betweenw-full">
            <div className="relative mb-4 w-full">
            <img
                                src={packages.img_url}
                                className='object-cover h-[225px] w-full rounded-lg'
                            />
            {country === 'EG' ? (
                    <>
                        {packages.discountPrice_egp && (
                            <div className="absolute px-2 border-red-700 h-7 border text-red-500 line-through bg-white bottom-[26px] font-semibold right-px rounded-tr rounded-br flex justify-center items-center md:text-base text-sm">
                                {packages.actualPrice_egp} EGP
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        {packages.discountPrice_usd && (
                            <div className="absolute px-2 border-red-700 h-7 border text-red-500 line-through bg-white bottom-[26px] font-semibold right-px rounded-tr rounded-br flex justify-center items-center md:text-base text-sm">
                                {packages.actualPrice_usd} USD
                            </div>
                        )}
                    </>
                )}
            </div>

            <div>
                <div className="flex justify-between w-full items-center mb-3 py-0.5">
                    <h1 className="font-semibold text-2xl">{packages.name}</h1>

                    <div className="rounded py-1.5 min-w-[90px] px-3 flex justify-center items-center gap-0.5 font-bold bg-primary text-white">
                        {country === "EG" ? (
                            <>
                                {packages.discountPrice_egp} <span className="text-sm uppercase">EGP</span>
                            </>
                        ) : (
                            <>
                                {packages.discountPrice_usd} <span className="text-sm uppercase">USD</span>
                            </>
                        )}
                    </div>
                </div>
                <div className=" mb-4">
                    <span className="font-medium text-sm text-lightGray/70">
                        <ReactMarkdown>{packages.description}</ReactMarkdown>
                    </span>
                </div>

            </div>
        </div>
    );
};

export default PackageCard;
